<template>
  <div class="external">
    <MainLoader/>
    <h2 class="title">
      <!-- TODO добавить перевод -->
      Authorizing...
    </h2>
  </div>
</template>

<script>
import { AuthAPI } from '@/api'
import MainLoader from '@/components/common/MainLoader';

export default {
  data() {
    return {
      
    };
  },
  components: {
    MainLoader,
  },
  methods: {

    async auth() {
      const bearer = await AuthAPI.loginWithTempToken(this.$route.params.token)
        .then(res => res.data.access_token);
      this.$store.commit('user/auth', bearer);
      await this.$store.dispatch('user/updateData');
      this.$router.push('/dashboard');
    }
  },
  created() {
    this.auth();
  },
}
</script>

<style lang="scss" scoped>
.external {

  display: flex;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;

  .title {
    margin-top: 70px;
  }

}
</style>
